/**
 * The card shape shared by the project and pipeline grids.
 *
 * **Content-height, not a fixed ratio.** These were briefly forced to 1:1. A
 * square looks tidy in a mockup and wrong in use: a card carries a name, a
 * two-line description, a metadata line and one button, which is nowhere near
 * as tall as it is wide — so a square left a large dead band under the button.
 * Height now follows the content.
 *
 * Cards in a row still line up, because CSS grid stretches its items: every
 * card in a row takes the height of the tallest, and the action sits on
 * `marginTop: auto` so the buttons align along the bottom instead of floating
 * at whatever height the description happened to leave them.
 *
 * Kept here rather than duplicated in both features so the two grids cannot
 * drift apart.
 */

import type { CSSProperties } from "react";

/** Spread onto a Mantine `Card` in a listing grid. */
export const listCardStyle: CSSProperties = {
  display: "flex",
  flexDirection: "column",
  // Stretch to the row's tallest card so a row reads as one band rather than a
  // ragged edge. Without this a short card would shrink to its own content.
  height: "100%",
};

/**
 * Spread onto the card's action (the Open button) so it anchors to the bottom
 * regardless of how much text sits above it.
 */
export const listCardActionStyle: CSSProperties = {
  marginTop: "auto",
  alignSelf: "flex-start",
};
